var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"outside-layout"},[_vm._t("outside-header",function(){return [_c('app-header'),_c('div',{staticClass:"app"},[_c('main',{staticClass:"outside-main"},[_c('div',{staticClass:"outside-content",attrs:{"name":"mainContent"}},[_vm._t("default")],2)]),_vm._t("outside-footer")],2),_c('app-footer')]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }